export enum PRODUCT_HOLDER_TYPES {
  OWNER = 'Owner',
  REPAIRER_WORKSHOP = 'RepairerWorkshop',
  REPAIRER_PARTNER = 'RepairerPartner',
  REPAIRER_HUB = 'RepairerHub',
  SUPPLIER = 'Supplier',
  STORE = 'Store',
  CARRIER = 'Carrier',
  EXTERNAL_CARRIER = 'ExternalCarrier',
  WAREHOUSE = 'Warehouse',
}
